/* istanbul ignore file */

export const INTEGRATION_EVENTS = {
  CONNECTION_STARTED: 'Integration Connection Started',
  CONNECTION_COMPLETED: 'Integration Connection Completed',
  CONNECTION_CLOSED: 'Integration Connection Closed',
  CONNECTION_FAILED: 'Integration Connection Failed',
  CONNECTION_DISCONNECTED: 'Integration Connection Disconnected',
  WORKFLOW_CREATED: 'Integration Workflow Created',
  WORKFLOW_DELETED: 'Integration Workflow Deleted',
  WORKFLOW_ENABLED: 'Integration Workflow Enabled',
  WORKFLOW_DISABLED: 'Integration Workflow Disabled',
  WORKFLOW_RUN_RETRIED: 'Integration Workflow Run Retried',
  RUN_LOG_OPENED: 'Integration Run Log Opened',
  PACKAGE_INSTALL_LINK_CLICKED: 'Integration Package Install Link Clicked',
  PACKAGE_INSTALL_CONFIRMED: 'Integration Package Install Confirmed',
} as const

export type IntegrationEventName =
  (typeof INTEGRATION_EVENTS)[keyof typeof INTEGRATION_EVENTS]
